<template>
  <div class="relative py-4">
    <vs-row class="flex justify-between items-center mb-4">
      <h5 class="flex items-center"><i v-if="isTitleIcon" class="dot"></i>{{ title }}</h5>
      <div class="flex items-center gap-4" v-if="controls && !board.readonly && !isPrint">
        <slot name="customControlBtn"></slot>
        <vs-button color="secondary" type="border" @click="openExcelPopup" > 엑셀 다운로드 </vs-button>
        <vs-button color="secondary" @click="handleAddRow"> 항목추가 </vs-button>
        <vs-button color="secondary" type="border" @click="handleRemoveRow"> 선택삭제 </vs-button>
      </div>
    </vs-row>

    <tr ref="doubleHead">
      <slot name="doubleHead"></slot>
    </tr>

    <vs-table ref="vsTable" :multiple="multiple && !isPrint && !board.readonly" v-model="checkData" noDataText="데이터가 없습니다" :data="list" class="w-full table" :class="[thema === 'label' && 'label-table']">
      <template slot="thead">
        <vs-th ><div class="w-full text-center">연번</div></vs-th>
        <vs-th ><div class="w-full text-center">부서명</div></vs-th>
        <vs-th style="width: 25%;"><div class="w-full text-center">이름</div></vs-th>
        <vs-th style="width: 25%;"><div class="w-full text-center">수검 여부</div></vs-th>
        <vs-th style="width: 25%;"><div class="w-full text-center">미수검 사유</div></vs-th>
      </template>

      <template slot-scope="{ data }">
        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data" style="box-shadow: none !important; transform: translateY(0px)" class="print-container">
          <vs-td class="text-center">
            <div>{{ indextr + 1 }}</div>
          </vs-td>
          <vs-td class="text-center">
            <span v-if="isPrint && cellData.type === 'textarea'" class="print-textarea text-left">
              {{ tr[cellData.id] }}
            </span>
            <ml-input v-else :readonly="board.readonly || tableData[0].readonly" v-model="tr[tableData[0].id]" :placeholder="tableData[0].placeholder" class="w-full flex-1" @click.stop />
          </vs-td>
          <vs-td class="text-center">
            <ml-input :readonly="board.readonly || tableData[1].readonly" v-model="tr[tableData[1].id]" :placeholder="tableData[1].placeholder" class="w-full flex-1" @click.stop />
          </vs-td>
          <vs-td class="text-center">
            <div class="flex justify-center" style="gap: 16px;">
              <vs-radio v-model="tr[tableData[2].id]" v-for="selectData in tableData[2].selectData" :vs-value="`${tableData[2].id}-${indextr}|${selectData}`"
                        :disabled="board.readonly" class="mr-4" >{{ selectData }}
              </vs-radio>
            </div>
          </vs-td>
          <vs-td class="text-center">
            <ml-input v-if="!tr[tableData[2].id] || tr[tableData[2].id].indexOf('미수검') >= 0" :readonly="board.readonly || tableData[3].readonly" v-model="tr[tableData[3].id]" :placeholder="tableData[3].placeholder" class="w-full flex-1"  @click.stop/>
          </vs-td>
        </vs-tr>
        <slot name="customTr"></slot>
      </template>
    </vs-table>
    <div class="grid grid-cols-12 summary">
      <div class="col-span-3 grid grid-cols-12">
        <div class="col-span-6 text-center">합계</div>
        <div class="col-span-6 text-center">
          <ml-input v-model="getSum" readonly :placeholder="tableData[0].placeholder" class="w-full flex-1" @click.stop />
        </div>
      </div>
      <div class="col-span-3 grid grid-cols-12">
        <div class="col-span-6 text-center">수검자 수</div>
        <div class="col-span-6 text-center">
          <ml-input v-model="getCheckedCount" readonly :placeholder="tableData[0].placeholder" class="w-full flex-1" @click.stop />
        </div>
      </div>
      <div class="col-span-3 grid grid-cols-12">
        <div class="col-span-6 text-center">미수검자 수</div>
        <div class="col-span-6 text-center">
          <ml-input v-model="getUncheckedCount" readonly :placeholder="tableData[0].placeholder" class="w-full flex-1" @click.stop />
        </div>
      </div>
      <div class="col-span-3 grid grid-cols-12">
        <div class="col-span-6 text-center">수검률(%)</div>
        <div class="col-span-6 text-center">
          <ml-input v-model="getCheckedPercent" readonly :placeholder="tableData[0].placeholder" class="w-full flex-1" @click.stop />
        </div>
      </div>
    </div>

    <popup-excel-download
      v-model="showExcelPopup"
      :list="excelList"
      :title="title"/>
  </div>
</template>

<script>
import DateSelector from "./selector/DateSelector";
import TimeSelector from "./selector/TimeSelector";
import PeriodPicker from "./PeriodPicker";
import CompanySelector from "@/components/selector/CompanySelector";
import PopupExcelDownload from "@/popup/PopupExcelDownload";

export default {
  name: "SpecificHealthExamTable",
  components: {
    PopupExcelDownload,
    PeriodPicker,
    TimeSelector,
    DateSelector,
    CompanySelector,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    controls: {
      type: Boolean,
      default: true,
    },
    multiple: {
      type: Boolean,
      default: true,
    },
    thema: {
      type: String,
      default: "default",
    },
    isTitleIcon: { type: Boolean, default: true },
    title: String,
    tableData: Array,
    value: Array,
  },
  data() {
    return {
      showExcelPopup: false,
      checkData: [],
      list: this.value,
      excelList: [],
      dateArrCheck: [],
      numberId: 0 < this.value.length ? this.value[this.value.length - 1].id : 0,
    };
  },
  watch: {
    value: {
      handler(value) {
        this.list = value;
        this.numberId = 0 < value.length ? value[value.length - 1].id : 0;
      },
    },
    list: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
  },
  created() {
    // 추가버튼때 데이터를 넣기위해 dateArr의 id 값을 찾는다.
    this.dateArrCheck = this.tableData.map((td) => {
      if (td.type === "dateArr") return td.id;
    });
  },
  computed: {
    getSum() {
      return this.list.length;
    },
    getUncheckedCount() {
      let count = 0;
      for (const row of this.list) {
        if (!row['input3'] || row['input3'].indexOf('미수검') >= 0) {
          count += 1;
        }
      }

      return count;
    },
    getCheckedCount() {
      let count = 0;
      for (const row of this.list) {
        if (row['input3'] && row['input3'].indexOf('미수검') < 0) {
          count += 1;
        }
      }

      return count;
    },
    getCheckedPercent() {
      const percent = Math.round(this.getCheckedCount * 10000 / this.getSum) / 100;
      if (isNaN(percent)) {
        return 0;
      } else {
        return percent;
      }
    }
  },
  mounted() {
    // 테이블 헤드 2단
    if (this.$slots.doubleHead) {
      const myElement = this.$refs.vsTable.$el.querySelector(".vs-table--thead");
      myElement.insertAdjacentElement("afterbegin", this.$refs.doubleHead);
    }
  },
  methods: {
    // 항목추가
    handleAddRow() {
      const addData = { id: ++this.numberId };
      if (0 < this.dateArrCheck.length) {
        this.dateArrCheck.map((_adc) => {
          addData[_adc] = {};
        });
      }
      // 기본 값이 설정된 경우, 적용한다
      for (const row of this.tableData) {
        if (row.type === 'text' && typeof row.default !== 'undefined') {
          addData[row.id] = row.default;
        }
      }

      this.list.push(addData);
    },
    // 선택삭제
    handleRemoveRow() {
      const selectedIds = this.checkData.map((item) => item.id);
      this.list = this.list.filter((item) => !selectedIds.includes(item.id));

      this.checkData = [];
    },
    openExcelPopup() {
      this.showExcelPopup = true;

      this.excelList = [];

      for (const row of this.list) {
        let examType = '미수검';
        if (typeof row.input3 !== 'undefined' && row.input3.indexOf('수검') >= 0) {
          const split = row.input3.split('|');
          if (split.length > 1) {
            examType = split[1];
          }
        }

        this.excelList.push({
          '연번': row.id,
          '부서명': row.input1,
          '이름': row.input2,
          '수검 여부': examType,
          '미수검 사유': examType === '수검' ? '' : row.input4,
        })
      }
    }
  },
};
</script>
<style scoped lang="scss">
$border: 1px solid #cdcdcd;
.label-text {
  width: 110px;
  font-weight: 500;
  font-size: 14px;
}

.table ::v-deep {
  .con-tablex,
  .vs-con-tbody {
    overflow: visible;
  }
  .vs-con-tbody {
    background: none !important;
    border: 0 !important;
  }
  thead tr {
    background: #f9f9f9 !important;
    border-top: solid 1px #cdcdcd;
    border-bottom: solid 1px #cdcdcd;
  }
  tr {
    background: #fff !important;
    border-bottom: solid 1px #cdcdcd;
    position: relative;

    th {
      font-size: 14px !important;
      padding: 12px 0 !important;
    }
  }
  .input-span-placeholder {
    text-align: left;
  }
  textarea::placeholder {
    font-size: 12px;
    text-align: left;
    font-weight: 300;
    color: #b5b5b5;
  }
}
.table.label-table {
  ::v-deep {
    table,
    tr,
    th,
    td {
      border: 1px solid #cdcdcd;
    }
    td {
      padding: 4px !important;
      &:first-child {
        background: #f9f9f9;
      }
    }

    .is-selected {
      color: #3c3c3c;
      box-shadow: none !important;
      td:first-child {
        border-left: 1px solid #cdcdcd !important;
      }
    }
  }
}
.summary {
  background: #f9f9f9 !important;
  border-bottom: solid 1px #cdcdcd;

  >div {
    padding: 6px 15px;
  }
  div {
    align-self: center;
    font-weight: 500;
    color: #3c3c3c;
    font-size: 14px;
  }
}
</style>
